import { useState, useEffect } from 'react';
import { postData } from "../../../../ApiServices/ApiService";
import { ORG_UPDATE_EMPLOYEE } from "../../../../ApiServices/BaseURL";
import { useNavigate } from "react-router-dom";
import { logFrontendException } from '../../../../Utils/Exception';
import { useTheme } from '../../../../GlobalContext/GlobalContext';

const UserAdditionalInformationController = (userInfo, isUserEditable,onRefresh) => {
    const navigate = useNavigate();
    const [additionalData, setAdditionalData] = useState(userInfo);
    const [fieldConfigs, setFieldConfigs] = useState([
        { label: "Designation", key: "emp_designation", type: "text", error: ""},
        { label: "Bank Account No.", key: "emp_bank_acct_no", type: "text", error: "" },
        { label: "IFSC Code", key: "emp_ifsc_code", type: "text", error: "" },
        { label: "Branch Code", key: "emp_branch_code", type: "text", error: "" },
        {
            label: "Payment Mode", key: "emp_payment_mode", type: "dropdown",
            options: [{ label: 'Online', value: 1 }, { label: 'Offline', value: 2 }],
            error: ""
        },
        {
            label: "Eligible for PF", key: "is_pf", type: "dropdown",
            options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
            error: ""
        },
        {
            label: "Eligible for ESI", key: "is_esi", type: "dropdown",
            options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
            error: ""
        },
        {
            label: "Eligible for PT", key: "is_pt", type: "dropdown",
            options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
            error: ""
        },
        {
            label: "Eligible for Variable Pay", key: "is_variable_pay", type: "dropdown",
            options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
            error: ""
        },

        { label: "Fixed Salary", key: "emp_fixed_salary", type: "text", error: "" },
        {
            label: "Disbursement",
            key: "disbursement_amount",
            type: "text"
        }
    ]);
    const { setIsLoginPopup } = useTheme();
    const [updateDeleteError, setUpdateDeleteError] = useState('');
    const [updateDeleteSuccess, setUpdateDeleteSuccess] = useState('');
    const [updateLoading, setUpdateLoading] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const pageName = 'UserAdditionalInformationController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    useEffect(() => {
        setAdditionalData(userInfo);
    }, [userInfo]);

    const handleInputChange = (key, value) => {
        setAdditionalData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleUpdateUser = () => {
        // setIsEditModalOpen(true);
        callUpdateUserAdditionalInfo();
    };

    const handleCloseEditModal = () => setIsEditModalOpen(false);
    const handleOpenEditModal = () => setIsEditModalOpen(true);

    const callUpdateUserAdditionalInfo = async () => {
        try {
            const updatedFieldConfigs = fieldConfigs.map((field) => ({
                ...field,
                error: "", // Reset errors initially for all fields
            }));

            let hasError = false;
            // Validate each field based on its key
            const validatedFields = updatedFieldConfigs.map((field) => {
                let error = "";
                const value = additionalData?.[field.key]; // Retrieve the value for this field using its key

                // Validation logic based on the key
                switch (field.key) {
                    case "emp_branch_code":
                        const trimmedEmpBranchCode = value?.trim() || "";
                        if (trimmedEmpBranchCode && trimmedEmpBranchCode.length > 10) {
                            error = `${field?.label} must be 10 characters or less.`;
                            hasError = true;
                        }
                        break;
                    default:
                        break;
                }

                return { ...field, error }; // Attach the error message to the field
            });

            // Update fieldConfigs with errors
            setFieldConfigs(validatedFields);

            if (hasError) {
                return; // Stop submission if there are validation errors
            }
            setUpdateDeleteError('');
            setUpdateDeleteSuccess('');
            setUpdateLoading(true);
            console.log('additionalData:-',additionalData)

            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "emp_id": additionalData?.emp_id,
                "action": "update_emp_additional_info",
                "emp_name": additionalData?.emp_name,
                "emp_designation": additionalData?.emp_designation || '',
                "emp_bank_acct_no": additionalData?.emp_bank_acct_no || '',
                "emp_ifsc_code": additionalData?.emp_ifsc_code || '',
                "emp_branch_code": additionalData?.emp_branch_code || '',
                "emp_payment_mode": additionalData?.emp_payment_mode?.value || additionalData?.emp_payment_mode || 0,
                "is_pf": additionalData?.is_pf?.value ?? additionalData?.is_pf ?? 0,
                "is_esi": additionalData?.is_esi?.value ?? additionalData?.is_esi ?? 0,
                "is_pt": additionalData?.is_pt?.value ?? additionalData?.is_pt ?? 0,
                "is_variable_pay": additionalData?.is_variable_pay?.value ?? additionalData?.is_variable_pay ?? 0,
                "emp_fixed_salary": additionalData?.emp_fixed_salary || ''
            };
            console.log('additional payload', payload);

            const response = await postData(ORG_UPDATE_EMPLOYEE, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setUpdateDeleteSuccess(responseData?.info || 'User additional information got updated successfully.');
                        setTimeout(() => {
                            onRefresh();
                            setUpdateDeleteSuccess('')
                        }, 3000);
                    } else {
                        setUpdateDeleteError(responseData?.info || 'Failed to update user additional information. Please try again.');
                        logFrontendException(storedUserId, pageName, "callUpdateUserAdditionalInfo", responseData?.info || '');
                    }
                } else {
                    setUpdateDeleteError(responseData?.info || 'Failed to update user additional information.');
                    logFrontendException(storedUserId, pageName, "callUpdateUserAdditionalInfo", responseData || '');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setUpdateDeleteError('Unauthorized access. Your session may have expired. Please log in again.');
                logFrontendException(storedUserId, pageName, "callUpdateUserAdditionalInfo", response || '');
                setIsLoginPopup(true)
            } else {
                setUpdateDeleteError('Error ocurred while updating user additional information.');
                logFrontendException(storedUserId, pageName, "callUpdateUserAdditionalInfo", response || '');
            }
        } catch (error) {
            setUpdateDeleteError(`Failed to update user additional information. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "callUpdateUserAdditionalInfo", error || '');
        } finally {
            setUpdateLoading(false);
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    return {
        handleUpdateUser,
        handleCancel,
        fieldConfigs,
        additionalData,
        handleInputChange,
        updateDeleteError,
        updateDeleteSuccess,
        updateLoading,
        isEditModalOpen,
        handleOpenEditModal,
        handleCloseEditModal,
        callUpdateUserAdditionalInfo,
    };
};

export default UserAdditionalInformationController;
